// extracted by mini-css-extract-plugin
module.exports = {"container":"Notification_container__3bTC4","toggleButton":"Notification_toggleButton__26X9w","badge":"Notification_badge__1gufQ"};